/**
 * components/hazard/WorkerLookupSection.js — Б/Д-ААР АЖИЛТАН ХАЙХ.
 *
 * Зөрчлийн маягтын ЭХЭНД. Б/Д бичээд Enter дарахад тухайн хүний зураг,
 * нэр, албан тушаал, цех, хэсэг, утас ил гарна.
 *
 * ⚠ ЯАГААД ХЭРЭГТЭЙ ВЭ:
 *   Зөрчил нь ХҮНД холбогддог. Урьд нь хариуцагчийг доод талын
 *   сонголтоос хайдаг байсан тул бүртгэгч «энэ Б/Д хэн бэ» гэдгийг
 *   баталгаажуулах боломжгүй байв. Буруу хүнд зөрчил бичигдэх нь
 *   хариуцлага тооцоход шууд алдаа болно.
 *
 * ⚠ ЗӨВХӨН Enter дарахад хайна, бичих бүрд БИШ. Ажилтны лавлах нь
 *   Redis-ээс ирдэг ч дугаар бүрэн бичигдээгүй байхад дуудвал
 *   «олдсонгүй» гэсэн улаан анхааруулга үсэг бүрд гарч, бөглөх явцыг
 *   тасалдуулна.
 *
 * ⚠ Олдсон хүнийг ХАРИУЦАГЧ болгож автоматаар тавихгүй. Зөрчил
 *   гаргасан хүн ба түүнийг арилгах хариуцагч нь ӨӨР байж болно
 *   (жишээ: ажилтан зөрчил гаргасан, мастер арилгана). Хүсвэл нэг
 *   товчоор хуулна.
 */
import React, { useState } from "react";
import { Button, Input, Spin, Tooltip, message } from "antd";

import { Card, SectionTitle } from "./common";
import { getWorkerByTn } from "src/api/request";

// Ажилтны зураг — бусад хуудастай ИЖИЛ эх сурвалж
// (71300/register/modal.js, accident/register/…).
const PHOTO_BASE = "https://minio-action.erdenetmc.mn/emp/";

const Row = ({ label, value }) =>
  value ? (
    <div style={{ display: "flex", gap: 6, fontSize: 12, lineHeight: 1.5 }}>
      <span style={{ color: "#8A94A6", minWidth: 78 }}>{label}</span>
      <span style={{ fontWeight: 600, color: "#1F2430" }}>{value}</span>
    </div>
  ) : null;

export default function WorkerLookupSection({ value = {}, onChange }) {
  const [tn, setTn] = useState("");
  const [busy, setBusy] = useState(false);
  const w = value.worker || null;

  const search = async () => {
    const q = String(tn || "").trim();
    if (!q) return;
    setBusy(true);
    try {
      const res = await getWorkerByTn(q);
      if (!res || !res.tn) {
        message.warning("Ажилтан олдсонгүй");
        onChange({ worker: null });
        return;
      }
      onChange({
        worker: {
          tn: String(res.tn),
          name: res.shortname || res.fullname || "",
          position: res.position_namemn || res.positionnamemn || "",
          tseh: res.tseh_namemn || "",
          negj: res.negj_namemn || "",
          // ⚠ `p_mob === "0"` нь «утас байхгүй» гэсэн БАЙХГҮЙН тэмдэг.
          //   Шууд харуулбал «0» гэсэн утас гарч, залгах гэж оролдоно.
          phone: res.p_mob && res.p_mob !== "0" ? res.p_mob : res.cert_mobile,
        },
      });
    } catch (e) {
      message.error(
        e?.response?.data?.message || "Мэдээлэл олдсонгүй — Б/Д-г шалгана уу",
      );
      onChange({ worker: null });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card>
      <SectionTitle>Зөрчил гаргасан ажилтан</SectionTitle>

      <div style={{ display: "flex", gap: 6 }}>
        <Input
          style={{ maxWidth: 200 }}
          placeholder="Б/Д бичээд Enter"
          value={tn}
          // Зөвхөн орон — үсэг бичихэд лавлахаас олдохгүй
          onChange={(e) => setTn(e.target.value.replace(/\D/g, ""))}
          onPressEnter={search}
          allowClear
        />
        <Button onClick={search} loading={busy} disabled={!tn}>
          Хайх
        </Button>
        {w ? (
          <Tooltip title="Энэ хүнийг зөрчил арилгах хариуцагч болгоно">
            <Button
              type="link"
              onClick={() =>
                onChange({ assigneeTn: w.tn, assigneeName: w.name })
              }
            >
              Хариуцагч болгох
            </Button>
          </Tooltip>
        ) : null}
      </div>

      <Spin spinning={busy}>
        {w ? (
          <div
            style={{
              display: "flex",
              gap: 12,
              marginTop: 10,
              padding: 10,
              border: "1px solid #E6E9EF",
              borderRadius: 10,
              background: "#FAFBFC",
            }}
          >
            <img
              src={PHOTO_BASE + w.tn + ".jpg"}
              alt={w.name}
              width={72}
              height={90}
              style={{
                objectFit: "cover",
                borderRadius: 8,
                background: "#EEF1F5",
                flexShrink: 0,
              }}
              // ⚠ Зураг байхгүй ажилтан бий. `onError`-гүй бол эвдэрсэн
              //   зургийн дүрс гарч, «систем алдаатай» мэт харагдана.
              onError={(e) => {
                e.currentTarget.style.visibility = "hidden";
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div
                style={{ fontWeight: 700, fontSize: 13.5, marginBottom: 2 }}
              >
                {w.name}
                <span
                  style={{
                    fontFamily: "monospace",
                    color: "#8A94A6",
                    fontWeight: 400,
                    marginLeft: 6,
                  }}
                >
                  {w.tn}
                </span>
              </div>
              <Row label="Албан тушаал" value={w.position} />
              <Row label="Цех" value={w.tseh} />
              <Row label="Хэсэг" value={w.negj} />
              <Row label="Утас" value={w.phone} />
            </div>
          </div>
        ) : null}
      </Spin>
    </Card>
  );
}
